(function () {
  'use strict';

  console.log(
    "%cyou weren't supposed to see this.\nfound something good. go touch grass or shop.\nthriftgoblin.com",
    'color:#D04408; font-family: monospace; font-size:14px;'
  );

  var seq = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  var pos = 0;
  var overlay = null;
  var originalTitle = document.title;

  document.addEventListener('keydown', function (e) {
    pos = (e.key === seq[pos]) ? pos + 1 : 0;
    if (pos === seq.length) {
      pos = 0;
      window.location.href = '/discount/GOBURIFOUND?redirect=/';
    }
  }, { passive: true });

  window.addEventListener('blur', function () {
    document.title = 'come back 👀';
  });
  window.addEventListener('focus', function () {
    document.title = originalTitle;
  });

  function isCheckoutTrigger(el) {
    if (!el) return false;
    if (el.name === 'checkout') return true;
    if (el.getAttribute && el.getAttribute('href') === '/checkout') return true;
    if (el.classList && (el.classList.contains('cart__checkout-button') || el.classList.contains('checkout-button'))) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('button, a, input[type="submit"]');
    if (!el || !isCheckoutTrigger(el)) return;
    overlay = overlay || document.getElementById('tg-stamp-overlay');
    if (overlay) overlay.classList.add('tg-stamp-active');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') !== -1) {
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        var original = btn.textContent;
        btn.textContent = "goblin's got it...";
        setTimeout(function () { btn.textContent = original; }, 2500);
      }
    }
  });
})();
